/**
 * Default create body for the dev booking form (aligned with test scripts; times are ISO UTC).
 * Use `defaultBookingCreateBody()` so start/end reflect “now” when the form loads or resets to create.
 */
import { bufferedStartReferenceNow } from '../utils/bookingScheduleDefaults';

/** Checkbox options for Bookings → Create (IDs align with sample asset addons in dev scripts). */
export const BOOKING_CREATE_ADDON_OPTIONS = [
  { addonId: 76, label: 'Addon 76', hint: 'e.g. $25 · sample catalog' },
  { addonId: 77, label: 'Addon 77', hint: 'e.g. $40' },
  { addonId: 78, label: 'Addon 78', hint: 'e.g. no extra charge' },
  { addonId: 79, label: 'Addon 79', hint: 'e.g. low-cost extra' },
] as const;

export function defaultBookingCreateBody(): Record<string, unknown> {
  const start = bufferedStartReferenceNow();
  const end = new Date(start.getTime() + 7 * 60 * 60 * 1000);
  return {
    asset_id: '9f8d7de5-995e-4fa5-b780-a1910b9acad5',
    amount_of_people: 4,
    start_date: start.toISOString(),
    end_date: end.toISOString(),
    total_price: 1000.0,
    addons: [],
  };
}

/** Create-booking defaults with a specific asset id (from Assets list → Book). */
export function bookingCreateBodyForAsset(assetId: string): Record<string, unknown> {
  return {
    ...defaultBookingCreateBody(),
    asset_id: assetId.trim(),
  };
}

export function emptyBookingCreateBody(): Record<string, unknown> {
  return {
    asset_id: '',
    amount_of_people: null,
    start_date: '',
    end_date: '',
    total_price: null,
    addons: [],
  };
}
